module.exports = __webpack_public_path__ + "static/media/宝丽来相机.2ae0510d.png";